import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ClerkProvider } from "@clerk/react";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { VideoProvider } from "./context/VideoContext";
import Layout from "./components/Layout";
import LandingPage from "./pages/LandingPage";
import EventsPage from "./pages/EventsPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import SelectRolePage from "./pages/SelectRolePage";
import SSOCallbackPage from "./pages/SSOCallbackPage";
import UserDashboard from "./pages/UserDashboard";
import AdminDashboard from "./pages/AdminDashboard";
import SidequestsPage from "./pages/SidequestsPage";
import SidequestDetailPage from "./pages/SidequestDetailPage";
import UserProfilePage from "./pages/UserProfilePage";
import AdminSidequestsPage from "./pages/AdminSidequestsPage";
import AdminFeedbackPage from "./pages/AdminFeedbackPage";
import SettingsPage from "./pages/SettingsPage";
import TermsOfServicePage from "./pages/TermsOfServicePage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import ProtectedRoute from "./components/ProtectedRoute";
import "@/App.css";

const CLERK_PUBLISHABLE_KEY = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

function App() {
  if (!CLERK_PUBLISHABLE_KEY) {
    console.error("Missing REACT_APP_CLERK_PUBLISHABLE_KEY");
    return <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A] text-white">Missing Clerk configuration</div>;
  }

  return (
      <ClerkProvider publishableKey={CLERK_PUBLISHABLE_KEY}>
        <AuthProvider>
          <VideoProvider>
            <BrowserRouter>
              <Toaster 
                position="top-right" 
                richColors 
                theme="dark"
                toastOptions={{
                  style: {
                    background: '#121212',
                    border: '1px solid rgba(255,255,255,0.1)',
                  }
                }}
              />
              <Routes>
              <Route path="/" element={<Layout />}>
                <Route index element={<LandingPage />} />
                <Route path="events" element={<EventsPage />} />
                <Route path="login" element={<LoginPage />} />
                <Route path="register" element={<RegisterPage />} />
                <Route path="terms" element={<TermsOfServicePage />} />
                <Route path="privacy" element={<PrivacyPolicyPage />} />
                <Route path="select-role" element={<SelectRolePage />} />
                <Route path="sso-callback" element={<SSOCallbackPage />} />
                <Route path="sidequests" element={<SidequestsPage />} />
                <Route path="sidequests/:id" element={<SidequestDetailPage />} />
                <Route path="u/:username" element={<UserProfilePage />} />
                {/* Settings - accessible to any authenticated user */}
                <Route path="settings" element={
                  <ProtectedRoute roles={["customer", "business", "admin"]}>
                    <SettingsPage />
                  </ProtectedRoute>
                } />
                {/* User Dashboard - accessible to any authenticated user */}
                <Route path="user-dashboard" element={
                  <ProtectedRoute roles={["customer", "business", "admin"]}>
                    <UserDashboard />
                  </ProtectedRoute>
                } />
              <Route path="admin/sidequests/*" element={
                <ProtectedRoute roles={["admin"]}>
                  <AdminSidequestsPage />
                </ProtectedRoute>
              } />
              <Route path="admin/feedback" element={
                <ProtectedRoute roles={["admin"]}>
                  <AdminFeedbackPage />
                </ProtectedRoute>
              } />
              <Route path="admin/*" element={
                <ProtectedRoute roles={["admin"]}>
                  <AdminDashboard />
                </ProtectedRoute>
              } />
            </Route>
            </Routes>
          </BrowserRouter>
          </VideoProvider>
        </AuthProvider>
      </ClerkProvider>
  );
}

export default App;
